<div class="game-card__prize">
  <div class="game-card__prize__title">Prize{{ range ? ' range' : '' }}:</div>
  <div class="game-card__prize__value">
    <fz-currency [value]="prize"></fz-currency><span *ngIf="range"> - </span>
    <fz-currency [value]="prizeRangeEnd" *ngIf="range"></fz-currency>
  </div>
</div>
